import { Controller } from "@hotwired/stimulus";

const WARNINGS = {
  Feet: [0.083, 500],
  Inches: [1, 500 * 12],
  Meters: [0.01, 152.4],
  Centimeters: [1, 15240],
};

// Connects to data-controller="storage-area--form"
export default class extends Controller {
  static targets = ["tierType", "unit", "dimensionField"];

  connect() {
    const $elem = $(this.element);
    $elem.find(".datepicker").datepicker();
    $elem.find(".selectpicker").selectpicker("refresh");

    this.tierTypeTargets.forEach((tierType) =>
      this.tierChange({ target: tierType })
    );

    this.dimensionChange();
  }

  tierChange(ev) {
    const value = ev.target.value;

    [...ev.target.form.querySelectorAll("[data-tier-type]")].forEach((elem) => {
      elem.classList.toggle("d-none", elem.dataset.tierType !== value);
    });
  }

  dimensionChange() {
    const unit = this.unitTarget.value;

    if (!unit) {
      this.dimensionFieldTargets.forEach((field) => {
        field.querySelector("input").classList.remove("is-invalid");
      });
      return;
    }

    this.dimensionFieldTargets.forEach((field) => {
      const input = field.querySelector("input");

      if (input.value.trim().length === 0) {
        input.classList.remove("is-invalid");
        return;
      }

      const [min, max] = WARNINGS[unit];
      const value = parseFloat(input.value);

      let warningText = null;
      if (value < min) {
        warningText = "Warning: Dimension unusually small";
      } else if (value > max) {
        warningText = "Warning: Dimension unusually large";
      }

      if (warningText) {
        field.querySelector(".invalid-feedback").textContent = warningText;
        input.classList.add("is-invalid");
      } else {
        input.classList.remove("is-invalid");
      }
    });
  }
}
